module.exports = __webpack_public_path__ + "img/ESH_Web_banner_night.16cc5ae1.png";